export const getIndicatorColor = data => {
  if (data.length === 0) {
    return "white";
  }
  const hasError = data.some(item => item.count > 0);
  if (hasError) {
    return "#FF0000";
  }
  return "green";
};

export const LINKS_PATH = [
  {
    label: "Pocs manquants",
    link: `/nextgen/dimpoc`
  },
  {
    label: "Visites en erreur",
    link: `/nextgen/visitserror`
  },
  {
    label: "Visites manquantes",
    link: `/nextgen/visitsmissing`
  },
  {
    label: "Visites à traiter",
    link: `/nextgen/visitstoprocess`
  },
  {
    label: "Visites sans media",
    link: `/` // TODO add screen for media missing
  }
];



// WEBPACK FOOTER //
// src/components/nextgenindicators/NextGenIndicators.utils.js